import {HttpClient} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {catchError, Observable, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {Solicitante} from '../models/Solicitante';

@Injectable({
  providedIn: 'root'
})
export class SolicitanteService {

  private readonly solicitanesUrl = environment.solicitantesUrl;

  constructor(private readonly httpClient: HttpClient) { }

  public getSolicitantes(): Observable<Solicitante[]> {
    return this.httpClient.get<Solicitante[]>(this.solicitanesUrl);
  }

  public addUpdate(solicitante: Solicitante, add: boolean): Observable<Solicitante> {
    if (add) {
      return this.add(solicitante);
    } else {
      return this.update(solicitante);
    }
  }

  public add(solicitante: Solicitante): Observable<Solicitante> {
    return this.httpClient.post<Solicitante>(this.solicitanesUrl , solicitante).pipe(
      catchError((err) => {
        console.log("Saving failed for solicitante: " + solicitante.solicitante);
        return throwError(err);
      })
    );
  }

  public update(solicitante: Solicitante): Observable<Solicitante> {
    return this.httpClient.put<Solicitante>(this.solicitanesUrl , solicitante).pipe(
      catchError((err) => {
        console.log("Saving failed for solicitante: " + solicitante.solicitante);
        return throwError(err);
      })
    );
  }

  public getByDock(dock: string): Observable<Solicitante[]> {
    return this.httpClient.get<Solicitante[]>(this.solicitanesUrl + "/bydock/" + dock);
  }

  exists(firstName: string, lastName: string): Observable<boolean> {
    let fullName: string = (lastName + ", " + firstName);
    return this.httpClient.get<boolean>(this.solicitanesUrl + "/exists/" + fullName);
  }
}
